import { provideApolloClient } from '@vue/apollo-composable';
import { defineStore } from 'pinia';
import { GetEnvironmentQuery } from '@/generated/graphqlUser';
import { apolloClient } from '@/graphql/apolloClient';
import { GetEnvironment } from '@/graphql/documents/loginqueries/environment.graphql';
import { LoginOption, MainConfig } from './types';

const initialMainConfig: MainConfig = {
  ENVIRONMENTNAME: '',
  KEYCLOAK_CLIENTID: '',
  KEYCLOAK_URL: '',
  KEYCLOAK_REALM: '',
  KEYCLOAK_SUPPORTTOOL_CLIENTID: '',
  KEYCLOAK_SUPPORTTOOL_REALM: '',
  I18N_LOCALE: '',
  I18N_FALLBACK_LOCALE: '',
  APP_API_URL: '',
  GRAPHQL_URL: '',
  urlToHelp: '',
  GRAPHQL_OPTIONS: {},
  GRAPHQL_WS_OPTIONS: { uri: '' },
  CommitHash: '',
  loginOption: '',
};

export const useMainStore = defineStore('main', () => {
  provideApolloClient(apolloClient);

  const mainConfig = reactive<MainConfig>(initialMainConfig);
  const startupError = ref<'backend_unavailable' | null>(null);

  // GETTERS
  const getLoginOption = computed(() => {
    return mainConfig.loginOption;
  });
  // ACTIONS
  function setStartupError(type: 'backend_unavailable') {
    startupError.value = type;
  }
  async function fetchEnvironment() {
    const result = await apolloClient.query<GetEnvironmentQuery>({
      query: GetEnvironment,
      context: { clientName: 'userapi' },
    });
    if (result.data) {
      const en = result.data.environment;
      if (mainConfig.ENVIRONMENTNAME !== en.branch) {
        mainConfig.ENVIRONMENTNAME = en.branch;
      }
      mainConfig.KEYCLOAK_CLIENTID = en.idpClientId;
      mainConfig.KEYCLOAK_URL = en.idpUrl;
      mainConfig.KEYCLOAK_REALM = en.idpRealm;
      mainConfig.KEYCLOAK_SUPPORTTOOL_CLIENTID = en.supportToolIdPClientId;
      mainConfig.KEYCLOAK_SUPPORTTOOL_REALM = en.supportToolIdPRealm;
      mainConfig.CommitHash = en.commitHash || '';
    }
  }
  function setLoginOption(option: LoginOption) {
    mainConfig.loginOption = option;
  }
  return { mainConfig, startupError, setStartupError, fetchEnvironment, getLoginOption, setLoginOption };
});
